// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateEnquiryContactUsExistingCustomerDocument = `
    mutation createEnquiryContactUsExistingCustomer($input: EnquiryContactUsInput!) {
  createEnquiryContactUsExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useCreateEnquiryContactUsExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateEnquiryContactUsExistingCustomerMutation, SchemaTypes.CreateEnquiryContactUsExistingCustomerMutationVariables>(CreateEnquiryContactUsExistingCustomerDocument);
};